"use server";

import { bookmarkMediaProduct } from "@/services/rest/bookmark";

export async function toggleBookmarkAction(mediaId: number) {
  await bookmarkMediaProduct({ id: mediaId });
  return { isMyBookmark: true };
}
